import React, { ElementType } from "react";
import { Button, SxProps, Theme } from "@mui/material";
import { Link } from "react-router-dom";
import { FONT_SECONDARY } from "@/theme/typography";

interface IProps {
  label: string;
  IconComponent: ElementType;
  isLink?: boolean;
  to?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

const ButtonWithIcon: React.FC<IProps> = ({
  sx,
  label,
  IconComponent,
  isLink = false,
  to,
  onClick,
}) => {
  const buttonProps: React.ComponentProps<typeof Button> & {
    component?: ElementType;
    to?: string;
  } = {
    children: label,
    onClick: !isLink ? onClick : undefined,
  };

  if (isLink && to) {
    buttonProps.component = Link as ElementType;
    buttonProps.to = to;
  }

  return <Button
    variant="text"
    color="primary"
    endIcon={<IconComponent />}
    {...buttonProps}
    sx={{
      fontFamily: FONT_SECONDARY,
      paddingX: 0,
      ...sx
    }} />;
}

export default ButtonWithIcon;
